(ns minorodata.vcs.api
  (:require
   [minorodata.app.utils :refer [assoc-some]]
   [minorodata.vcs.model :refer [->vcs-config ->vcs-repo ->vcs-user-link]]
   [mold-http.core :refer [reg-event-http]]
   [re-posh.core :as re-posh]))


(defn get-config-request []
  {:http-xhrio
   {:id     :get-vcs-config-request
    :method :GET
    :url    "/api/vcs/config"}})

(defn get-config-callback [_ [error resp]]
  (if (some? error)
    {:dispatch [:app.events/add-snack :error "Failed to fetch VCS config"]}
    (let [ev (if @(re-posh/subscribe [:vcs-config/pull])
               :vcs-config/update :vcs-config/add)]
      {:dispatch [ev (->vcs-config (assoc-some (:config resp)
                                               :provider (:provider resp)))]})))

(reg-event-http
 :vcs.api/get-config
 get-config-request
 get-config-callback)


(defn update-config-request [_ [config]]
  {:http-xhrio
   {:id     :update-vcs-config-request
    :method :POST
    :url    "/api/vcs/config"
    :params config}})

(defn update-config-callback [_ [error resp]]
  (if (some? error)
    {:dispatch [:app.events/add-snack :error "Failed to update VCS config"]}
    {:dispatch-n [[:vcs-config/update (->vcs-config (:config resp))]
                  [:app.events/add-snack :success "Updated VCS config"]]}))

(reg-event-http
 :vcs.api/update-config
 update-config-request
 update-config-callback)


(defn delete-config-request []
  {:http-xhrio
   {:id     :delete-vcs-config-request
    :method :DELETE
    :url    "/api/vcs/config"}})

(defn delete-config-callback [_ [error]]
  (if (some? error)
    {:dispatch [:app.events/add-snack :error "Failed to delete VCS config"]}
    {:dispatch-n [[:vcs-config/delete]
                  [:app.events/add-snack :success "Deleted VCS config"]]}))

(reg-event-http
 :vcs.api/delete-config
 delete-config-request
 delete-config-callback)


(defn get-repos-request []
  {:http-xhrio
   {:id     :get-vcs-repos-request
    :method :GET
    :url    "/api/vcs/repos"}})

(defn get-repos-callback [_ [error resp]]
  (if (some? error)
    {:dispatch [:app.events/add-snack :error "Failed to fetch VCS repos"]}
    {:dispatch [:vcs-repo/add-many (mapv ->vcs-repo (:repositories resp))]}))

(reg-event-http
 :vcs.api/get-repos
 get-repos-request
 get-repos-callback)

(defn install-github-request []
  {:http-xhrio
   {:id     :install-github-request
    :method :POST
    :url    "/api/vcs/github/install-link"
    :params {:redirect-url (str js/window.location.origin "/admin?tab=account&vcs-installed=github")}}})

(defn install-github-callback [_ [error resp]]
  (if (some? error)
    {:dispatch [:app.events/add-snack :error "Failed to update VCS config"]}
    (do (js/window.open (:url resp) "_blank")
        nil)))

(reg-event-http
 :vcs.api/install-github
 install-github-request
 install-github-callback)


;; --- Self-scoped GitHub identity linking --------------------------------
;; Same pattern as install-github: GET stores the status in re-posh, POST
;; opens the GitHub authorize URL in a new tab, DELETE unlinks and refetches.

(defn get-user-link-status-request []
  {:http-xhrio
   {:id     :get-vcs-user-link-request
    :method :GET
    :url    "/api/vcs/github/user-link"}})

(defn get-user-link-status-callback [_ [error resp]]
  (when (nil? error)
    (let [ev (if @(re-posh/subscribe [:vcs-user-link/pull])
               :vcs-user-link/update :vcs-user-link/add)]
      {:dispatch [ev (->vcs-user-link resp)]})))

(reg-event-http
 :vcs.api/get-user-link-status
 get-user-link-status-request
 get-user-link-status-callback)


;; Popup window name + localStorage key shared with the modal's storage listener.
(def github-link-window-name "vcs-github-link-oauth")

(defn link-github-user-request []
  ;; redirect-url is loopback under local dev, which the dev ALB WAF 403s; use a
  ;; non-loopback host when testing the link flow locally.
  {:http-xhrio
   {:id     :link-github-user-request
    :method :POST
    :url    "/api/vcs/github/user-link"
    ;; For local dev: the loopback redirect-url is 403'd by the dev WAF, so swap
    ;; in the non-loopback override below (popup self-closes, but reopen the modal
    ;; to see Connected — auto-refetch can't fire cross-origin).
    ;; :params {:redirect-url "https://app.dev.kleene.ai/callback.html"}}})
    :params {:redirect-url (str js/window.location.origin "/callback.html")}}})

(defn link-github-user-callback [_ [error resp]]
  (if (some? error)
    {:dispatch [:app.events/add-snack :error "Failed to link GitHub account"]}
    ;; redirect.html sets sessionStorage.requestKey then bounces to GitHub;
    ;; callback.html self-closes and writes localStorage[window-name] on return.
    (do (js/window.open
         (str js/window.location.origin
              "/redirect.html?auth-uri=" (js/encodeURIComponent (:url resp)))
         github-link-window-name
         "width=600,height=800")
        nil)))

(reg-event-http
 :vcs.api/link-github-user
 link-github-user-request
 link-github-user-callback)


(defn unlink-github-user-request []
  {:http-xhrio
   {:id     :unlink-github-user-request
    :method :DELETE
    :url    "/api/vcs/github/user-unlink"}})

(defn unlink-github-user-callback [_ [error _resp]]
  (if (some? error)
    {:dispatch [:app.events/add-snack :error "Failed to unlink GitHub account"]}
    {:dispatch-n [[:vcs.api/get-user-link-status]
                  [:app.events/add-snack :success "Unlinked GitHub account"]]}))

(reg-event-http
 :vcs.api/unlink-github-user
 unlink-github-user-request
 unlink-github-user-callback)


(defn install-azure-request []
  {:http-xhrio
   {:id     :install-azure-request
    :method :POST
    :url    "/api/vcs/azure/install-link"
    :params {:redirect-url (str js/window.location.origin "/admin?tab=account&vcs-installed=azure")}}})

(defn install-azure-callback [_ [error resp]]
  (if (some? error)
    {:dispatch [:app.events/add-snack :error "Failed to update VCS config"]}
    (do (js/window.open (:url resp) "_blank")
        nil)))

(reg-event-http
 :vcs.api/install-azure
 install-azure-request
 install-azure-callback)

(defn full-sync-request [mode]
  {:http-xhrio
   {:id     (keyword (str "full-sync-" mode "-request"))
    :method :POST
    :url    "/api/vcs/full-sync"
    :params {:mode mode}}})

(defn full-sync-callback [_ [error _resp]]
  (if (some? error)
    {:dispatch [:app.events/add-snack :error "Failed to trigger full VCS sync"]}
    {:dispatch [:app.events/add-snack :success "Full VCS sync started"]}))

(reg-event-http
 :vcs.api/full-sync-outbound
 (fn [_] (full-sync-request "outbound"))
 full-sync-callback)

(reg-event-http
 :vcs.api/full-sync-inbound
 (fn [_] (full-sync-request "inbound"))
 full-sync-callback)
